import React, { useEffect, useState } from "react";
import { AvForm } from "availity-reactstrap-validation";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import {
  Card,
  CardBody,
  Col,
  Container,
  Button,
  Row,
  Label,
} from "reactstrap";
import SweetAlert from "react-bootstrap-sweetalert";
import Select from "react-select";
import { CircularProgress } from "@material-ui/core";

const statusOptions = [
  { value: "Y", label: "Enable" },
  { value: "N", label: "Disable" },
];

const ReferLink = (props) => {
  const [buttonLink, setButtonLink] = useState("");
  const [status, setStatus] = useState(statusOptions[0].value);
  const [existingId, setExistingId] = useState(null);
  const [loader, setLoader] = useState(false);
  const [successAlert, setSuccessAlert] = useState(false);
  const [errorAlert, setErrorAlert] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [token, setToken] = useState("");
  const [dataLoaded, setDataLoaded] = useState(false);

  const getReferFriendButtons = (token) => {
    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);
    myHeaders.append(
      "Cookie",
      "__cfduid=d5b74235daa6f013fde0aba762ec288811620640208"
    );

    var requestOptions = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow",
    };

    fetch(
      `${process.env.REACT_APP_TOKRI_API_URL}/api/referfriendbuttons`,
      requestOptions
    )
      .then((response) => response.json())
      .then((result) => {
        if (result?.data && result.data.length > 0 && result.data[0]) {
          const item = result.data[0];
          setButtonLink(item?.button_link || "");
          setStatus(item?.status || statusOptions[0].value);
          setExistingId(item?.id || null);
        }
        setDataLoaded(true);
      })
      .catch((error) => {
        console.log("error", error);
        setDataLoaded(true);
      });
  };

  useEffect(() => {
    const token = localStorage.getItem("AuthenticationToken");
    setToken(token);
    if (token) {
      getReferFriendButtons(token);
    }
  }, []);

  const handleSubmit = () => {
    if (!buttonLink || !buttonLink.trim()) {
      setErrorMessage("Please enter refer link text");
      setErrorAlert(true);
      return;
    }

    setLoader(true);

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);
    myHeaders.append("cache-control", "no-cache");
    myHeaders.append(
      "Cookie",
      "__cfduid=d5b74235daa6f013fde0aba762ec288811620640208"
    );

    var formdata = new FormData();
    formdata.append("button_link", buttonLink.trim());
    formdata.append("status", status);

    if (existingId) {
      formdata.append("id", existingId);
      formdata.append("_method", "PUT");

      var updateRequestOptions = {
        method: "POST",
        headers: myHeaders,
        body: formdata,
        redirect: "follow",
        processData: false,
        mimeType: "multipart/form-data",
        async: true,
        crossDomain: true,
      };

      fetch(
        `${process.env.REACT_APP_TOKRI_API_URL}/api/referfriendbuttons/update`,
        updateRequestOptions
      )
        .then((response) => {
          if (response.status === 200) {
            setSuccessAlert(true);
            setLoader(false);
          } else {
            setErrorMessage("Unable to update");
            setErrorAlert(true);
            setLoader(false);
          }
        })
        .catch((error) => {
          console.log("error", error);
          setLoader(false);
        });
    } else {
      var addRequestOptions = {
        method: "POST",
        headers: myHeaders,
        body: formdata,
        redirect: "follow",
        processData: false,
        mimeType: "multipart/form-data",
        async: true,
        crossDomain: true,
      };

      fetch(
        `${process.env.REACT_APP_TOKRI_API_URL}/api/referfriendbuttons`,
        addRequestOptions
      )
        .then((response) => {
          if (response.status === 201 || response.status === 200) {
            setSuccessAlert(true);
            setLoader(false);
            getReferFriendButtons(token);
          } else {
            setErrorMessage("Unable to add");
            setErrorAlert(true);
            setLoader(false);
          }
        })
        .catch((error) => {
          console.log("error", error);
          setLoader(false);
        });
    }
  };

  const renderSuccessAlert = () => (
    <SweetAlert
      title="Success!"
      success
      confirmBtnBsStyle="success"
      onConfirm={() => {
        setSuccessAlert(false);
        setLoader(false);
        if (!existingId) {
          getReferFriendButtons(token);
        }
      }}
      onCancel={() => setSuccessAlert(false)}
    >
      {existingId
        ? "Refer Link updated successfully."
        : "Refer Link added successfully."}
    </SweetAlert>
  );

  const renderFailureAlert = () => (
    <SweetAlert
      title="Warning!"
      warning
      confirmBtnBsStyle="warning"
      onConfirm={() => {
        setErrorAlert(false);
        setLoader(false);
      }}
    >
      {errorMessage ? errorMessage : "Error. Something went wrong."}
    </SweetAlert>
  );

  if (!dataLoaded) {
    return (
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs title="Refer a Friend" breadcrumbItem="Refer Link" />
          <div className="text-center py-5">
            <CircularProgress
            size={50} value={100} color={"black"} />
          </div>
        </Container>
      </div>
    );
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs title="Refer a Friend" breadcrumbItem="Refer Link" />
          <Row>
            <Col lg={12}>
              <Card>
                <CardBody>
                  <AvForm className="needs-validation">
                    <Card>
                      <CardBody>
                        <Row>
                          <Col lg={4} md={10} sm={10}>
                            <div className="mb-3">
                              <Label>Refer Link Text</Label>
                              <textarea
                                rows={4}
                                className="form-control"
                                value={buttonLink}
                                onChange={(e) => setButtonLink(e.target.value)}
                                placeholder="Enter refer link text"
                              />
                            </div>
                          </Col>
                          <Col md={1}></Col>
                        </Row>
                        <Row>
                          <Col lg={4} md={10} sm={10}>
                            <div className="mb-3">
                              <Label>Status</Label>
                              <Select
                                isSearchable={false}
                                value={statusOptions.find(
                                  (opt) => opt.value === status
                                )}
                                onChange={(e) => setStatus(e.value)}
                                options={statusOptions}
                                placeholder="Choose..."
                                required
                              />
                            </div>
                          </Col>
                          <Col md={1}></Col>
                        </Row>
                        <div style={{ textAlign: "left" }} className="btn-sec">
                          <Button
                            disabled={loader}
                            style={{
                              color: "#ffffff",
                              width: "80px",
                            }}
                            className="btn btn-success"
                            onClick={() => handleSubmit()}
                            type="button"
                          >
                            {loader ? (
                              <CircularProgress
                                size={15}
                                value={100}
                                color={"white"}
                              />
                            ) : (
                              "Save"
                            )}
                          </Button>
                        </div>
                      </CardBody>
                    </Card>
                  </AvForm>
                </CardBody>
              </Card>
            </Col>
          </Row>
          {successAlert ? renderSuccessAlert() : null}
          {errorAlert ? renderFailureAlert() : null}
        </Container>
      </div>
    </React.Fragment>
  );
};

export default ReferLink;
